<!-- Copy documents from source project (copy mode only) -->
<div class="border-bottom" *ngIf="isCopyMode">
  <!-- Header with Select All -->
  <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 px-3 py-2 section-header">
    <div class="d-flex align-items-center gap-2 small text-truncate text-dark-primary" style="max-width:100%">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true" class="flex-shrink-0 text-danger-primary">
        <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
      </svg>
      <span class="text-truncate">Copy documents from {{ projectName || 'Project' }}-(<span class="d-none d-sm-inline">{{ sourceProjectDocuments.length }} files</span><span class="d-sm-none">{{ sourceProjectDocuments.length }}</span>)</span>
    </div>

    <div class="d-flex align-items-center gap-2 flex-shrink-0" *ngIf="sourceProjectDocuments.length > 0">
      <span class="small d-none d-sm-inline text-dark-primary">Select All</span>
      <span class="small d-sm-none text-dark-primary">All</span>
      <button class="btn checkbox-btn" (click)="toggleSourceAll()" aria-label="Select all">
        <mat-icon [style.color]="isAllSourceSelected() ? '#cc0000' : '#9aa0a6'" class="checkbox-icon">
          {{ isAllSourceSelected() ? 'check_box' : 'check_box_outline_blank' }}
        </mat-icon>
      </button>
    </div>
  </div>

  <!-- Source documents list -->
  <div class="source-docs-list overflow-auto">
    <div class="d-flex justify-content-between align-items-center px-2 py-2 border-bottom"
         *ngFor="let f of sourceProjectDocuments" [class.bg-danger-subtle]="f.checked">
      <div class="d-flex align-items-center gap-2 gap-sm-3 overflow-hidden min-width-0">
        <button class="btn checkbox-btn flex-shrink-0" (click)="toggleSourceFileSelection(f)" title="Select">
          <mat-icon [style.color]="f.checked ? '#cc0000' : '#9aa0a6'" class="checkbox-icon">
            {{ f.checked ? 'check_box' : 'check_box_outline_blank' }}
          </mat-icon>
        </button>

        <div class="d-none d-sm-flex align-items-center justify-content-center flex-shrink-0 file-icon-container">
          <app-document-type-icon [item]="f"></app-document-type-icon>
        </div>

        <div class="overflow-hidden min-width-0">
          <div class="small text-truncate text-dark-primary" title="{{f.file_name}}">{{f.file_name}}</div>
          <div class="small text-secondary text-truncate" [title]="(f?.department_ids || []).join(', ')">
            Department: {{ f?.department_ids?.length ? f.department_ids.join(', ') : f?.department_id }}
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center gap-1 gap-sm-2 flex-shrink-0">
        <button class="btn icon-btn" (click)="previewRequested.emit(f)" title="Preview">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                  stroke="#374151" stroke-width="1.2" fill="none"
                  stroke-linecap="round" stroke-linejoin="round"></path>
            <circle cx="12" cy="12" r="2.5" stroke="#374151" stroke-width="1.2"></circle>
          </svg>
        </button>

        <button class="btn icon-btn" (click)="downloadRequested.emit(f)" title="Download">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
               viewBox="0 0 24 24" fill="none" stroke="#374151" stroke-width="1.2"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 15V3"></path>
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <path d="m7 10 5 5 5-5"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Empty state when no source documents -->
    <div class="d-flex flex-column align-items-center justify-content-center py-4 text-center" *ngIf="sourceProjectDocuments.length === 0">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#D1D5DB" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="8" y1="13" x2="16" y2="13"></line>
        <line x1="8" y1="17" x2="16" y2="17"></line>
        <line x1="8" y1="9" x2="10" y2="9"></line>
      </svg>
      <div class="text-dark-primary mb-1 mt-2" style="font-size: 16px; font-weight: normal;">No documents found</div>
      <div class="text-secondary small mb-0">This project has no documents to copy.</div>
    </div>
  </div>
</div>
